module.exports = __webpack_public_path__ + "static/custom-alerts-poster-0b4ed930691e794e9c2ca5665af4b703.jpg";